export const WALLET_UPDATED = 'WalletUpdated';
export const CLEAR_UPDATED_WALLET_DATA = 'CLEAR_UPDATED_WALLET_DATA';
